import { render, staticRenderFns } from "./HeaderLayout.vue?vue&type=template&id=20f692e2&"
import script from "./HeaderLayout.vue?vue&type=script&lang=js&"
export * from "./HeaderLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports